import { DesktopMenu } from '../App';
import RSVP from '../components/RSVP';

export default function ContactUs() {
  return (
    <>
      <DesktopMenu />
      <div className="text-center text-secondary bg-linen mb-8 font-archer text-[20px] px-8 py-12">
        <h1 className="font-bold text-[22px] bg-secondary/20 w-fit mx-auto">Any questions?</h1>
        <small className="text-sm mb-4 block">(and you've already checked the FAQs page)</small>

        <div className="font-semibold">Feel free to reach out,</div>
        <div className="font-semibold">in order of who will respond faster:</div>

        <div className="mt-4">
          <div className="italic">Raenna: +1 213 422 5761 / raenna.mabel@gmail.com</div>
          <div className="italic">Patrick: +1 323 434 8292 / galicia.patrick@gmail.com</div>
        </div>
      </div>
      <RSVP />
    </>
  );
};
